import { useState } from 'react';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import OutlinedPageBox from '../global/OutlinedPageBox';
import CenteredContentLayout from '../global/CenteredContentLayout';
import useBusiness from '../../hooks/businesses/useBusiness';
import QueueSettingsFormModal from './QueueSettingsFormModal';
import { getCheckInURL, onDownloadQRCode } from '../../helpers/queue';
import { isUserAdminOrManager } from '../../utils/global/helper';
import useUser from '../../hooks/global/useUser';

function EmptyQueue() {
  const { user } = useUser();
  const { business } = useBusiness();

  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const isEditingAllowed = !!user && isUserAdminOrManager(user);

  const url = getCheckInURL(business);

  return (
    <>
      <OutlinedPageBox>
        <CenteredContentLayout
          image={{
            src: '/queue.svg',
            alt: 'Queue',
          }}
          title="Your walk-in queue is empty!"
          description="Post your check-in QR code or send clients your check-in link to start adding clients to your walk-in queue!"
          button={{
            text: 'Download QR Code',
            onClick: () => onDownloadQRCode(business),
          }}
          secondaryButton={
            isEditingAllowed
              ? {
                  icon: SettingsOutlinedIcon,
                  text: 'Walk-in Queue Settings',
                  onClick: () => {
                    setIsSettingsOpen(true);
                  },
                }
              : undefined
          }
          maxWidth="750px"
          imageMaxWidth="120px"
          copyContent={url}
        />
      </OutlinedPageBox>
      {isSettingsOpen && (
        <QueueSettingsFormModal open onClose={() => setIsSettingsOpen(false)} />
      )}
    </>
  );
}

export default EmptyQueue;
